import React from 'react';
import { personal, stats } from '../data/portfolioData';
import photo from '../photo.jpg';
import './Hero.css';

export default function Hero() {
  return (
    <section id="hero" className="hero">
      {/* Text column */}
      <div className="hero-text">
        <div className="hero-badge fade-up d1">
          <span className="badge-dot" />
          Available for opportunities
        </div>

        <h1 className="hero-title fade-up d2">
          Blockchain &amp;<br />
          Full Stack<br />
          <em className="highlight">Developer</em>
        </h1>

        <p className="hero-desc fade-up d3">{personal.bio}</p>

        <div className="hero-btns fade-up d4">
          <a href="#projects" className="btn-primary" onClick={e => {
            e.preventDefault();
            document.querySelector('#projects')?.scrollIntoView({ behavior: 'smooth' });
          }}>
            View My Work <span>→</span>
          </a>
          <a href="#contact" className="btn-outline" onClick={e => {
            e.preventDefault();
            document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
          }}>
            Get In Touch
          </a>
        </div>

        <div className="hero-stats fade-up d5">
          {stats.map(s => (
            <div key={s.label} className="stat-item">
              <div className="stat-num">{s.num}</div>
              <div className="stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Visual column */}
      <div className="hero-visual fade-up d2">
        <div className="hero-photo-wrap">
          <img src={photo} alt="Shakeel Khan" className="hero-photo" />
          <div className="photo-card photo-card-1">
            <div className="card-icon">⛓️</div>
            <div className="card-label">Blockchain Dev</div>
            <div className="card-val">4+ Years</div>
          </div>
          <div className="photo-card photo-card-2">
            <div className="card-icon">🏅</div>
            <div className="card-label">Bronze Medalist</div>
            <div className="card-val">UOL · CS</div>
          </div>
        </div>
      </div>
    </section>
  );
}
